import React, { useEffect } from "react";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import { ApiResponse } from "../../../services/api";
import Warehouse from "../../../types/warehouse";

interface WarehouseTableProps {
    rows: any[];
    columns: GridColDef[];
    width?: string;
    getRowClassName?: (params: { indexRelativeToCurrentPage: number }) => string;
    apiResponse: ApiResponse<Warehouse> | null;
    paginationModel: any;
    setPaginationModel: any;
    sortModel?: GridSortModel;
    onSortModelChange?: (model: GridSortModel) => void;
}

const WarehouseTable: React.FC<WarehouseTableProps> = ({
    rows,
    columns,
    width = "100%",
    getRowClassName,
    apiResponse,
    paginationModel,
    setPaginationModel,
    sortModel,
    onSortModelChange,
}) => {
  useEffect(() => {
    const styleElementId = 'dynamic-row-colors';
    let styleTag = document.getElementById(styleElementId);
  
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = styleElementId;
      document.head.appendChild(styleTag);
    }

    const uniqueColors = Array.from(new Set(
      rows.map(r => r.color).filter(c => /^([0-9A-F]{3}){1,2}$/i.test(c))
    ));

    const uniqueFontColors = Array.from(new Set(
      rows.map(r => r.fontColor).filter(c => /^([0-9A-F]{3}){1,2}$/i.test(c))
    ));
  
    styleTag.innerHTML = uniqueColors.map(color => {
      const className = `row-color-${color}`;
      return `
        .MuiDataGrid-row.${className} {
          background-color: #${color} !important;
        }
      `;
    }).join('\n');

    styleTag.innerHTML += uniqueFontColors.map(color => {
      const className = `row-font-color-${color}`;
      return `
        .MuiDataGrid-row.${className} {
          color: #${color} !important;
        }
      `;
    }).join('\n');
  }, [rows]);

  return (
    <div style={{ height: '100%', width, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={36}
        columnHeaderHeight={40}
        pageSizeOptions={[10, 20, 40, 100]}
        pagination
        checkboxSelection={false}
        getRowClassName={getRowClassName}
        paginationMode='server'
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={apiResponse?.data?.totalItems ?? 0}
        sortingMode='server'
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#f5f5f5",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#b2d1ff",
        },
        "& .MuiTablePagination-selectLabel": {
          marginTop: "14px",
        },
        "& .MuiTablePagination-displayedRows": {
          marginTop: "14px",
        },
        "& .MuiDataGrid-cell[id='id']": {
          cursor: 'pointer !important',
        },
        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
          outline: "none",
        },
        "& .MuiDataGrid-row:focus, & .MuiDataGrid-row:focus-within": {
          outline: "none",
        }
        }}
      />
      </div>
    </div>
  );
};

export default WarehouseTable;
